// component/FiltrerTransactionModal.js
import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  ButtonGroup,
} from "reactstrap";
import '../utils/detail.css';
const FiltrerVersementModal = ({ isOpen, toggle, onApply = [] }) => {
  const [status, setStatus] = useState("");
  const [createdAt, setCreatedAt] = useState("")
  const applyFilters = () => {
    onApply({
      status,
      createdAt,
    });
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}contentClassName="custom-modal-si">
      <ModalHeader toggle={toggle} className="custom-modal-header"style={{color:'#000000'}}>
        Filtrer
      </ModalHeader>
      <ModalBody>
    <div className="mb-3">
   <div className="d-flex align-items-center me-3">
    <label className=" mb-0 me-2 lanel">Statut</label>
    <div style={{ width: "100%", border:'1px solid #0000001A' }}></div>
  </div>
  <ButtonGroup>
   <Button
  style={{
    backgroundColor: status === "" ? "#3761FF14" : "#0000000F",
    color: status === "" ? "#3761FF" : "#000000",
    border:status===""? "1px solid #3761FF14": "1px solid #0000000F",
    fontWeight: status === "" ? 500 : 400,
    margin: "10px",
    borderRadius: "6px",
    fontSize:'14px'
  }}
  onClick={() => setStatus("")}
>
  Tous
</Button>

    <Button
     style={{
        backgroundColor: status === "SUCCESS" ? "#EBFFEA" : "#0000000F",
        color: status === "SUCCESS" ? "#349C32" : "#000000",
        border:status==="SUCCESS"? "1px solid #EBFFEA": "1px solid #0000000F",
        fontWeight: status === "SUCCESS" ? 500 : 400,
        margin: "10px",
        borderRadius: "6px",
        fontFamily:"Poppins",
        fontSize:'14px'
      }}
      onClick={() => setStatus("SUCCESS")}
    >
      Succés
    </Button>
    <Button
     style={{
        backgroundColor: status === "PENDING" ? "#f9ffeaff" : "#0000000F",
        color: status === "PENDING" ? "#f1c40f" : "#000000",
        border:status==="PENDING"? "1px solid #f9ffeaff": "1px solid #0000000F",
        fontWeight: status === "PENDING" ? 500 : 400,
        margin: "10px",
        borderRadius: "6px",
         fontFamily:"Poppins",
        fontSize:'14px'
      }}
      onClick={() => setStatus("PENDING")}
    >
      En cours
    </Button>
  </ButtonGroup>
  </div>
       <div className="mb-3">
         <div className="d-flex align-items-center me-3">
        <label className=" mb-0 me-2 lanel">Date</label>
        <div style={{ width: "100%", border:'1px solid #0000001A' }}></div>
      </div>
      <div className="col-4" style={{margin:"10px"}}>
        <FormGroup>
        <Input
          type="date"
          value={createdAt}
          onChange={(e) => setCreatedAt(e.target.value)}
        />
      </FormGroup>
      </div>
       </div>
    <Button className="button apply-filter-btn"  onClick={applyFilters}>
          Appliquer le filtre
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default FiltrerVersementModal;
